import React, { useMemo } from "react";

import { More as OptionIcon } from "iconsax-reactjs";
import Typography from "../../../Typography";
import { Tooltippy } from "../../../../actions/Tippy";
import { useTimeCounter } from "../../../../hooks/useTimeCounter";
import TimeCounterMinute from "../../../../containers/TimeCounterMinute";
import { formatTextAndUnicode } from "../../../../utils/formatTextAndUnicode";

import { ReactComponent as Bullet } from "../../../../build/images/TimeCounter/Bullet.svg";
import { ReactComponent as Timer } from "../../../../build/images/TimeCounter/timer.svg";
import { ReactComponent as PinIcon } from "../../../../build/images/PinAssets/pin-v2.svg";

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const CardItem = ({
  call,
  contactId,
  style,
  renderProfilePicture,
  destinomsg,
  changeAtd,
  infoUsers,
  atdSimult,
  IPCurrent,
  statusAgent,
  // createJSON,
  dateExhib,
  lastMsg,
  tempoExcedido,
  msgIcon,
  renderTagInfo,
  renderMenu,
  openTooltipId,
  setOpenTooltipId,
  LightTooltip,
  keyToTransfer,
}) => {
  const key = useMemo(() => {
    return keyToTransfer;
  }, [keyToTransfer]);
  const { time, days } = useTimeCounter(call ? call.recuperationtime : null);
  const hasPinAndNoReadActive =
    call && call.isPined && (call.qtdmessage >= 1 || call.isNoRead);
  return (
    <div
      className={`card-chats ${
        call.idatendimento === contactId.idatendimento ? "active" : ""
      } `}
      key={key}
      style={style}
    >
      <div className="card-chats__main">
        {renderProfilePicture(call.idmidia, call, destinomsg)}
        <div className="card-chats__infos">
          <div
            className="card-chats__infos-infoMsg"
            onClick={() =>
              changeAtd(infoUsers, call, atdSimult, IPCurrent, statusAgent)
            }
          >
            <div className="name-time" style={{ overflow: "hidden" }}>
              <Tooltippy content={call.cliente ? createJSON(call.cliente) : ""}>
                <Typography.H4
                  className={"name-info flex-1"}
                  color={"gray-600"}
                >
                  {createJSON(call.cliente)}
                </Typography.H4>
              </Tooltippy>
              <div
                className="datetime datetimenew"
                style={{ flex: "0 0 auto", minWidth: "max-content" }}
              >
                <span>{dateExhib}</span>
                <div className="datetimenew__time-counter">
                  <Bullet />
                  <Timer />
                  <TimeCounterMinute horario={time} day={days} />
                </div>
              </div>
            </div>
            <div className="message-tag">
              {lastMsg ? (
                <Tooltippy
                  placement="top"
                  content={
                    <span className="tippy-msg">{createJSON(lastMsg)}</span>
                  }
                >
                  <div
                    className={`preview-container${
                      tempoExcedido ? " less-width" : ""
                    } ${hasPinAndNoReadActive ? "pin-and-noread-active" : ""}`}
                  >
                    {msgIcon}
                    <Typography.H5
                      className={`preview${msgIcon ? " less-width" : ""}`}
                      color={"gray-180"}
                    >
                      {createJSON(lastMsg)}
                    </Typography.H5>
                  </div>
                </Tooltippy>
              ) : (
                <div
                  className={`preview-container${
                    tempoExcedido ? " less-width" : ""
                  } ${hasPinAndNoReadActive ? "pin-and-noread-active" : ""}`}
                ></div>
              )}
              {renderTagInfo(call, tempoExcedido)}
              {call && call.isPined && (
                <div
                  className="card-item-pin-container"
                  style={{ justifySelf: "flex-end" }}
                >
                  <PinIcon />
                </div>
              )}
            </div>
          </div>
          <LightTooltip
            className="new-light-tolltip"
            title={renderMenu(call)}
            placement="right"
            open={openTooltipId === key}
            onClose={() => setOpenTooltipId(null)}
          >
            <div
              className={`action tippy-context-menu${
                openTooltipId === key ? " active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                setOpenTooltipId(openTooltipId === key ? null : key);
              }}
            >
              <OptionIcon variant="outline" color="#757575" />
            </div>
          </LightTooltip>
        </div>
        {/* {call && call.isPined && (
          <div className="card-item-pin-container">
            <PinIcon />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default CardItem;
